import API from '../api';
import PublicAPI from '../public.api';

export const AuthAPI = {
    auth: async (body: any) => {
        const res = await PublicAPI.post('/api/v1/external/sharedbox/security/auth', body);
        const resData = res.data;
        return resData.data;
    },
    getPublicInformation: async (sharedBoxId: string, randomKey: string) => {
        const res = await PublicAPI.get(`/api/v1/external/sharedbox/${sharedBoxId}/hint?randomKey=${randomKey}`);
        const resData = res.data;
        return resData.data;
    },
    requestOTP: async (sharedBoxId: string, randomKey: string) => {
        const res = await PublicAPI.post(`/api/v1/external/sharedbox/${sharedBoxId}/otp/request?randomKey=${randomKey}`);
        const resData = res.data;
        return resData.data;
    },
    getSession: async () => {
        const res = await API.get('/api/v1/external/sharedbox/security/session');
        const resData = res.data;
        return resData.data;
    },
};

export default AuthAPI;